<template>
<div><AboutUsNav></AboutUsNav>
<!-- <div class="aboutwe_container_Swiper" style="width: 100%;height: 833px;margin-top: 24px;position: relative;">
				<h3 class="about-h3-fz">发展历程</h3>
    			<div>
    				<span class="wenzi1">中拍协会员，吉林拍协会员全国范围内成立多家分公司.企业腾飞发展之年</span>
    				<div class="yuan1"></div>
    				<div class="xian1"></div>
    				<span class="nian1">2020</span>
 					<div style="position: absolute;"></div>
    			</div>
    			<div>
    				<span class="wenzi2">获得拍卖行业资质</span>
    				<div class="yuan2"></div>
    				<div class="xian2"></div>
    				<span class="nian2">2019</span>
    			</div>
    				<span class="wenzi3">全国科技行业自主创新五百强企业</span>
    				<div class="y3"></div>
    				<div class="xian3"></div>
    			<div>
    				<span class="nian3">2018</span>
    			</div>
    			<div>
    				<span class="wenzi4">吉林AAAAA级诚信企业</span>
    				<div class="yuan4"></div>
    				<div class="xian4"></div>
    				<span class="nian4">2017</span>
    			</div>
    			<div>
    				<span class="wenzi5">国家互联网电子商务诚信示范企业</span>
    				<div class="yuan5"></div>
    				<div class="xian5"></div>
    				<span class="nian5">2016</span>
    			</div>
    			<div>
    				<span class="wenzi6">建立中国拆迁网</span>
    				<div class="yuan6"></div>
    				<div class="xian6"></div>
    				<span class="nian6">2015</span>
    			</div>
    			<div>
    				<span class="wenzi7">公司成立注册资本2189万</span>
    				<div class="yuan7"></div>
    				<div class="xian7"></div>
    				<span class="nian7">2014</span>
    			</div>

    		</div> -->
			<div class="Boxc">
				<div class="xian"></div>
				<div class="box"><div class="yuan"></div><div class="time">2014年05月</div><div class="wez">吉林省崇晟科贸有限公司成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2015年12月</div><div class="wez">吉林省崇晟科技有限公司成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2016年10月</div><div class="wez">中国互联网电子商务诚信示范企业</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2017年10月</div><div class="wez">吉林省崇晟企业管理咨询有限公司成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2018年05月</div><div class="wez">取得拍界商标注册证</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年06月</div><div class="wez">取得计算机软件著作权</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年06月</div><div class="wez">吉林AAAAA诚信企业</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年06月</div><div class="wez">全国科技自主创新五百强企业</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年09月</div><div class="wez">中国科技行业资质等级证书</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年09月</div><div class="wez">品牌强国自主品牌优选示范工程</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2019年12月</div><div class="wez">取得拍卖行业资质</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年01月</div><div class="wez">成为中国拍卖行业协会会员单位</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年04月</div><div class="wez">吉林省拍界科技有限公司成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年04月</div><div class="wez">成为吉林省拍卖行业协会会员单位</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年05月</div><div class="wez">唐山分部成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年06月</div><div class="wez">山东泰安分部、长春第一事业部成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年07月</div><div class="wez">吉林市、辽源市、沈阳市分部成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年08月</div><div class="wez">拍界拍卖有限公司成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年08月</div><div class="wez">太原、哈尔滨分部成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年08月</div><div class="wez">齐齐哈尔、佳木斯、牡丹江分部成立</div></div>
				<div class="box"><div class="yuan"></div><div class="time">2020年09月</div><div class="wez">天津第一事业部成立</div></div>
			</div>
			
			
</div>
</template>

<script>
// import { formatDate } from '@/assets/js/date.js'
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
    metaInfo: {
        title: "拍界——唤醒您的沉睡资产",
        meta: [{
            name: "keywords",
            content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }, {
            name: "description",
            content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
        }]
    },
    data (){
        return{
            subjects: [],
            //分页器
            paginator:{
                first: null,
                before: null,
                previous: null,
                current: 1,
                last: null,
                next: null,
                total_pages: null,
                total_items: null,
                limit: 20,
            },
        }
    },
    
    created(){
        // 显示公共栏
        this.$emit('header', true)
        this.$emit('footer', true)
        
        // 加载路由参数
        this.getRouteQuery()
        // 请求列表数据
        this.getSubjects()

        // 页面至顶部
        window.scrollTo(0,0);
    },
  components: {
    AboutUsNav
  }
    
    
}
</script>
<style scoped>
.Boxc{
		line-height: 42px;
		width: 100%;
		padding: 20px 0;
		margin-top: 20px;
		position: relative;
		background:#fff;
	}
.time{
		width: 89px;
		display:inline-block;
		margin-left: 6%;
	}
.wez{
		display:inline-block;
		margin-left: 7%;
	}
.box{
		text-align: left;
		color: black;
	}
.box:hover{
		text-align: left;
		background: #cccccc;
		color: #fff;
		
	}
.yuan{
		margin-left: 17%;
		background-color: red;border-radius: 50%;width: 17px;height: 17px;border:2px solid #cccccc;
		display: inline-block;
		vertical-align: middle;
		position: relative;
	}
.xian{
	border-left: 2px solid #cccccc;
    position: absolute;
    height: 830px;
    margin-left: 17.8%;
    top: 5%;
    z-index: 0;
}
@media screen and (max-width: 540px){
	.yuan{
    margin-left: 1%;
    background-color: red;
    border-radius: 50%;
    width: 17px;
    height: 17px;
    border: 2px solid #cccccc;
    display: inline-block;
    vertical-align: middle;
    position: relative;
}
.time{
	width: 89px;
	display:inline-block;
	margin-left: 2%;
	}
.wez{
	display: inline-block;
    margin-left: 5%;
	}
.xian{
	border-left: 2px solid #cccccc;
    position: absolute;
    height: 830px;
    margin-left: 3.5%;
    top: 5%;
    z-index: 0;
	}
	
}
</style>